export enum DiagnosisEventType {
    Opportunity = 1,
    Validation = 2,
    Other = 3
}
